import { UpdateEvent } from "../GUIEvents";

export default class LoginHelper {
    static get(field:string) { return sessionStorage.getItem(field) || undefined }
    static onUpdate(field:string) {
        return (e:UpdateEvent<string>) => e.value && sessionStorage.setItem(field, e.value)
    }
}